"use strict";
import {
  Type,
  type,
  Runtime,
  Dom,
  Event,
  ajax,
  parseJSON,
  Text,
  isNodeHidden,
  ready,
  addCustomEvent,
  findChildren,
  data,
} from "main.core";
import { VSCore } from "vsbx.core";
import "./style.css";
const getTag = function getTag(value) {
  return Object.prototype.toString.call(value);
};
const isNodeList = function isNodeList(value) {
  return Type.isObjectLike(value) && getTag(value) === "[object NodeList]";
};
const isJQueryNode = function isJQueryNode(node) {
  return node instanceof jQuery;
};
const findNodes = function (node, container) {
  if (type.isDomNode(node)) {
    return [node];
  }
  if (type.isArray(node)) {
    return node;
  }
  if (type.isNotEmptyString(node)) {
    if (type.isArray(container)) container = container[0];
    if (!container || !type.isDomNode(container)) container = document;
    return container.querySelectorAll(node);
  }
  return [];
};
let formUtil = {
  findNodes: findNodes,
  /**
   * Description
   * Простая проверка формы
   * @property
   * @name validateDIV
   * @kind method
   * @memberof formUtil
   * @type {function}
   * @param {any} selector
   * @param {boolean} isHideAnim?
   * @param {string} tagSelector?
   * @param {boolean} elements?
   * @returns {boolean}
   */
  validateDIV: function (
    selector,
    isHideAnim = false,
    tagSelector = "[required]",
    elements = false
  ) {
    let d = findNodes(selector),
      parentSelector = ".form-field";
    if (isNodeList(d) || type.isArray(d)) d = d[0];
    if (d || elements) {
      let arr = elements;
      if (!arr) arr = findNodes(tagSelector, d);
      for (let i = 0, l = arr.length; i < l; i++) {
        let input = arr[i];
        let p = input.closest(parentSelector);
        if (!p) p = input.parentNode.closest("div");
        if (input.setCustomValidity) input.setCustomValidity("");
        if (input.tagName === "DIV") {
          let inputsHidden = findNodes('input[type="hidden"]', input);
          if (
            inputsHidden.length === 0 ||
            (inputsHidden.length == 1 && inputsHidden[0].value == "")
          ) {
            p = input.parentNode;
            if (!isHideAnim) {
              //this.anim(p, true);
              let span = findNodes("span.invalid-feedback", p)[0];
              if (!span) {
                span = Dom.create("SPAN", {
                  attrs: { className: "invalid-feedback" },
                });
                p.append(span);
              }
              span.innerHTML = input.dataset.validationMessage;
              Dom.addClass(p, "was-validated");
              BX.focus(p);
            }
            return false;
          }
        } else if (!isHideAnim && !input.reportValidity()) {
          let b = true;
          if (!isHideAnim) {
            if (input.type == "file") {
              if (input.name.indexOf("[") !== -1) {
                if (findNodes('[type="file"]', p).length > 1) {
                  b = false;
                }
              }
            }
            if (b) {
              if (input.validationMessage) {
                let span = findNodes("span.invalid-feedback", p)[0];
                if (!span) {
                  span = Dom.create("SPAN", {
                    attrs: {
                      className: "invalid-feedback",
                    },
                  });
                  p.append(span);
                }

                span.innerHTML =
                  input.validationMessage +
                  (input.type == "url" ? " " + input.placeholder : "");
              }
              Dom.addClass(p, "was-validated");
              if (!Dom.isShown(input)) input = input.parentNode;
              Event.bind(input, "change", function (e) {
                if (this.type !== "file" && this.value !== "") {
                  Dom.removeClass(p, "was-validated");
                } else if (this.type == "file" && this.files.length) {
                  Dom.removeClass(p, "was-validated");
                }
              });
              BX.focus(input);
            }
          }
          if (b) return false;
        } else if (isHideAnim) {
          if (input.type === "checkbox") {
            if (!input.checked) return false;
          } else {
            if (input.value === "") return false;
          }
        }
        if (p) Dom.removeClass(p, "was-validated");
      }
    }
    return true;
  },
  /**
   * Description
   * Получить данные элемента
   * @property
   * @name getElementValue
   * @kind method
   * @memberof formUtil
   * @type {function}
   * @param {any} el
   * @returns {{ data: {}; length: number; files: number; }}
   */
  getElementValue: function (el) {
    var _data = {},
      length = 0,
      files = 0;
    switch (String(el.type).toLocaleLowerCase()) {
      case "file":
        if (!!el.files) {
          if (el.multiple) _data = [];
          for (let ii = 0; ii < el.files.length; ii++) {
            files++;
            var item = {
              name: el.name,
              value: el.files[ii],
              file: true,
            };
            if (el.multiple) {
              _data.push(item);
            } else {
              _data = item;
            }
            length += el.files[ii].size;
          }
        }
        break;
      case "radio":
      case "checkbox":
        if (el.checked) {
          _data = { name: el.name, value: el.value };
          length += el.name.length + el.value.length;
        }
        break;
      case "select-multiple":
        _data = [];
        for (var j = 0; j < el.options.length; j++) {
          if (el.options[j].selected) {
            _data.push({ name: el.name, value: el.options[j].value });
            length += el.name.length + el.options[j].length;
          }
        }
        break;
      case "undefined":
        var isContentEditable = parseJSON(el.getAttribute("contenteditable"));
        if (isContentEditable) {
          let v = el.innerText;
          if ((el.dataset.typeValue = "html")) {
            v = el.innerHTML;
          }
          _data = { name: el.getAttribute("name"), value: v };
          length += el.getAttribute("name").length + v.length;
        }
        break;
      default:
        _data = { name: el.name, value: el.value };
        length += el.name.length + el.value.length;
        break;
    }
    return {
      data: _data,
      length: length,
      files: files,
    };
  },
  buildFormData(formData, data, parentKey) {
    if (
      data &&
      typeof data === "object" &&
      !(data instanceof Date) &&
      !(data instanceof File)
    ) {
      Object.keys(data).forEach((key) => {
        formUtil.buildFormData(
          formData,
          data[key],
          parentKey ? `${parentKey}[${key}]` : key
        );
      });
    } else {
      const value = data == null ? "" : data;
      formData.append(parentKey, value);
    }
  },
  getFormData(data) {
    var formData = new FormData();
    if (type.isArray(data)) data = formUtil.convertArrayInObject(data);
    formUtil.buildFormData(formData, data);
    return formData;
  },
  arrayFormData(formData) {
    let arr = [];
    for (let [key, value] of formData) {
      arr.push({ name: key, value: value });
    }
    return arr;
  },
  convertArrayInObject(arr) {
    if (Type.isArray(arr)) {
      var a = {};
      arr.forEach(function (el) {
        a[el.name] = el.value;
      });
      return a;
    }
    return arr;
  },
  /**
   * Description
   * Сброс формы
   * @method
   * @name resetForm
   * @kind method
   * @memberof formUtil
   * @param {any} form
   * @returns {void}
   */
  resetForm(form) {
    let elements = [];
    if (isJQueryNode(form)) {
      elements = form.find(
        ':input[name]:not([type="hidden"]), select, input[type="checkbox"]'
      );
    } else if (type.isDomNode(form)) {
      elements = findNodes('[name]:not([type="hidden"])', form);
    }
    for (let i = 0, l = elements.length; i < l; i++) {
      let input = elements[i];
      if (input.type === "checkbox") {
        input.checked = !input.checked;
      } else {
        input.value = "";
      }
    }
  },
  /**
   * Получить значения формы или div
   * @method
   * @name serializeForm
   * @kind method
   * @memberof formUtil
   * @param {any} el
   * @param {boolean} isArray?
   * @returns {{} | null}
   */
  serializeForm(el, isArray = false) {
    var self = this;
    var data = isArray ? [] : {},
      file,
      elements;
    if (isJQueryNode(el)) {
      elements = el.find(":input");
    } else if (el.elements) {
      elements = el.elements;
    } else if (type.isFunction(el.querySelectorAll)) {
      elements = el.querySelectorAll("[name]");
    }
    if (elements) {
      for (let i = 0, l = elements.length; i < l; i++) {
        var element = elements[i];
        var d = self.getElementValue(element);
        if (d.length) {
          // if (!d.data.name) debugger;
          if (!file && d.files > 0) file = true;
          if (isArray) {
            data.push(d.data);
          } else {
            if (Type.isArray(d.data)) {
              d.data.forEach(function (e) {
                if (!data[e.name]) {
                  data[e.name] = [];
                }
                data[e.name].push(e.value);
              });
            } else {
              data[d.data.name] = d.data.value;
            }
          }
        }
      }
      if (file) data = self.getFormData(data);
      return data;
    }
    return null;
  },
};
let formControl = {
  createForm(
    node,
    jsonParams,
    dataProvider,
    isResultControl = false,
    isRegister = false
  ) {
    if (type.isPlainObject(node) && !type.isPlainObject(jsonParams)) {
      jsonParams = node;
      node = false;
    }
    jsonParams = parseJSON(jsonParams);
    if (!jsonParams) return false;
    /**
     * Creates and returns a new instance of the specified HTML element.
     * @param {string} tag - The tag name of the element to create.
     * @param {object} [params] - An object that contains one or more of the following properties:
     * @param {string} [params.tag] - The tag name of the element to create.
     * @param {object} [params.props] - An object that contains the element properties.
     * @param {object} [params.style] - An object that contains the element styles.
     * @param {object} [params.events] - An object that contains the event handlers for the element.
     * @param {object} [params.attrs] - An object that contains the element attributes.
     * @param {object} [params.dataset] - An object that contains list of data attributes.
     * @param {Array<Node>} [params.children] - An array of child elements.
     * @param {string} [params.text] - The text content of the element.
     * @param {Node|string} [params.html] - The HTML content of the element.
     * @returns {Node} The created element.
     */
    let params = VSCore.mergeEx(
      {
        props: {
          id: "ctrl_" + Text.getRandom(),
          className: "form",
        },
      },
      jsonParams.form.params
    );
    if (params.props.className.indexOf("form") == -1) {
      params.props.className += " form";
    }
    let form = Dom.create("DIV", params);
    if (type.isArray(jsonParams.formControl)) {
      jsonParams.formControl.forEach((option) => {
        formControl.createControl(form, option, dataProvider);
      });
    }

    if (type.isElementNode(node)) {
      node.appendChild(form);
      Dom.addClass(node, "form-built");
    }
    if (isResultControl) {
      let control = VSCore.CONTROL.add(form, jsonParams);
      return control;
    }
    if (isRegister) VSCore.CONTROL.registerControl(form);
    return form;
  },
  chkClassName(params, className) {
    if (params) {
      if (!params.props) {
        params.props = {};
      }
      if (!params.props.className) {
        params.props.className = className;
      } else if (params.props.className.indexOf(className + " ") == -1) {
        params.props.className += " " + className;
      }
    }
  },
  createControl(node, jsonParams, dataProvider) {
    jsonParams = parseJSON(jsonParams);
    if (!jsonParams) return false;
    let nodeControl;
    let createNode = (params, className) => {
      let bCh = false;
      if (type.isObjectLike(params.params)) {
        params = params.params;
        bCh = true;
      }
      if (
        !bCh &&
        type.isArray(params.children) &&
        params.children.length > 0 &&
        type.isPlainObject(params.children[0]) &&
        !params.children[0].params
      ) {
        bCh = true;
      }

      if (className) formControl.chkClassName(params, className);
      if (!type.isNotEmptyString(params.tag)) params.tag = "DIV";
      let n = Dom.create(params);

      if (bCh && type.isArray(params.children)) {
        params.children.forEach((item) => {
          formControl.createControl(n, item, dataProvider);
        });
      }
      return n;
    };
    switch (jsonParams.type) {
      case "ROW":
        nodeControl = createNode(jsonParams, "row");
        break;
      case "COL":
        nodeControl = createNode(jsonParams, "col");
        break;
      case "ACTION":
        jsonParams.params.events = {
          click: (e) => {
            if (type.isFunction(dataProvider[jsonParams.action.name])) {
              dataProvider[jsonParams.action.name](e, node);
            }
          },
        };
        nodeControl = createNode(jsonParams, "d-form-action");
        break;
      case "CUSTOM":
        nodeControl = VSCore.runFunction(
          jsonParams.customNameFunction,
          jsonParams,
          node,
          this
        );
        if (type.isElementNode(nodeControl)) {
          addClass(nodeControl, "custom-control");
        }
        break;
      case "FIELD":
        nodeControl = Dom.create("DIV", {
          props: {
            className: "form-field",
          },
        });
        let label, id;
        if (jsonParams.label) {
          label = createNode(jsonParams.label);
          id = "ctrl_field_" + Text.getRandom();
          label.setAttribute("for", id);
          Dom.addClass(label, "form-label");
          nodeControl.appendChild(label);
          // if (jsonParams.label.params.html == "Наши предложения"){
          //   debugger;
          // }
        }
        let input = createNode(jsonParams);
        if (label) {
          input.setAttribute("id", id);
        }
        nodeControl.appendChild(input);
        break;
      default:
        nodeControl = createNode(jsonParams);
        break;
    }
    let b = type.isElementNode(nodeControl);
    if (b) {
      data(nodeControl, "vs-json-params", jsonParams);
    }
    if (type.isElementNode(node) && b) node.appendChild(nodeControl);
    return nodeControl;
  },
  json(form, isObject = true) {
    let ob = {
      form: {},
      formControl: [],
    };
    let _findChildren = (el) => {
      let a = findChildren(el);
      if (!a) a = [];
      return a;
    };
    let arElement = _findChildren(form);
    let addChildren = (arr, elements) => {
      elements.forEach((el) => {
        if (el.className.indexOf("row ") !== -1) {
          let row = {
            type: "ROW",
            params: {
              props: {
                className: el.className,
              },
            },
            children: [],
          };
          addChildren(row.children, _findChildren(el));
          arr.push(row);
        } else if (el.className.indexOf("col ") !== -1) {
          let col = {
            type: "COL",
            children: [],
          };
          addChildren(col.children, _findChildren(el));
          arr.push(col);
        } else if (el.className.indexOf("form-field") !== -1) {
          let field = {
            type: "FIELD",
          };
          let label = findChildren(el, { tag: "label" });
          if (label && label.length) {
            label = label[0];
            field.label = {
              params: {
                tag: "label",
                html: label.innerHTML,
              },
            };
          }
          let input = findChildren(el, { className: "form-control" });
          if (input && input.length) {
            input = input[0];
            field.params = {
              tag: input.tagName,
              props: {
                className: "form-control",
              },
            };
            input.getAttributeNames().forEach((name) => {
              if (name !== "class")
                field.params.props[name] = input.getAttribute(name);
            });
          }
          let a = findChildren(el, { tagName: "DIV" });
          if (a && a.length) {
            field.children = [];
            addChildren(field.children, a);
          }
          arr.push(field);
        } else if (el.className.indexOf("custom-control") !== -1) {
          let customControl = {
            customNameFunction: data(el, "custom-name-function"),
            params: parseJSON(data(el, "custom-data")),
          };
          arr.push(customControl);
        } else {
          let add = (el) => {
            let q = {
              type: "FREE",
              params: {},
            };
            q.params.tag = el.tagName;
            el.getAttributeNames().forEach((name) => {
              if (name !== "class") {
                if (!q.params.attrs) q.params.attrs = {};
                q.params.attrs[name] = el.getAttribute(name);
              } else {
                if (!q.params.props) q.params.props = {};
                q.params.props["className"] = el.className;
              }
            });
            let ar = _findChildren(el);
            if (ar && ar.length) {
              q.children = [];
              addChildren(q.children, ar);
            } else {
              if (type.isNotEmptyString(el.innerHTML))
                q.params.html = el.innerHTML.trim();
            }
            arr.push(q);
          };
          if (!el.closest(".tel-input")) {
            add(el);
          } else {
            add(el.querySelector("INPUT"));
          }
        }
      });
    };
    arElement.forEach((el) => {
      addChildren(ob.formControl, [el]);
    });
    if (isObject) return ob;
    return JSON.stringify(ob);
  },
};
document.addEventListener("click", function (e) {
  if (e.target.closest(".form .btn-submit")) {
    let form = e.target.closest(".form");
    let d = BX.data(e.target),
      formData = BX.data(form);
    if (!d) d = {};
    if (form && formUtil.validateDIV(form)) {
      BX.showWait(form);
      let url = d.submitUrl
          ? d.submitUrl
          : form.getAttribute("action")
          ? form.getAttribute("action")
          : "/include/forms/action.php",
        data = formUtil.serializeForm(form);
      let params = {
        url: url,
        method: "POST",
        data: data,
        dataType: "html",
        onsuccess: function (html) {
          let data = parseJSON(html);
          console.log(data);
          if (data) {
            let autoHideDelay = 4000;
            if (data.delay) {
              autoHideDelay = data.delay;
            }
            Runtime.loadExtension("ui.notification").then((exports) => {
              BX.UI.Notification.Center.notify({
                content: data.alert.name + "<br>" + data.alert.message,
                autoHideDelay: autoHideDelay,
                position: "top-center",
              });
            });
          }
          BX.closeWait(form);
          formUtil.resetForm(form);
        },
        onfailure: function (data) {
          BX.closeWait(form);
          console.log(data);
        },
      };
      if (type.isFormData(data)) {
        params.preparePost = false;
        params.processData = false;
      }
      ajax(params);
    }
    e.preventDefault();
    return false;
  } else if (e.target.closest(".form .clean-input")) {
    let input = findNodes(".form-control", this.parentNode);
    if (input) input.value = "";
  }
});
const mutationObserver = window.MutationObserver;
const setForm = (el) => {
  let inputs = findNodes(".form [name]", el);
  inputs.forEach((el) => {
    el.addEventListener("invalid", function (e) {
      e.preventDefault();
    });
  });
  let formContainers = findNodes(".form-container:not(.control-init)", el);
  let providerClass;
  let arLazy = [];
  formContainers.forEach((container) => {
    VSCore.CONTROL.setDefaultNode(container);
    let configID = container.dataset.vsConfigName
      ? container.dataset.vsConfigName
      : container.id;
    let data = VSCore.getObject(configID);
    if (!data) data = container.dataset;
    if (type.isNotEmptyString(data.vsControllerName)) {
      let init = false,
        dataProvider,
        form,
        jsonForm = data.jsonForm,
        control;
      let setInit = () => {
        if (!init) {
          let createProvider = () => {
            dataProvider = new providerClass(container, data.configController);
            dataProvider.send = () => {
              if (formUtil.validateDIV(form)) {
                let formData = formUtil.serializeForm(form);
                dataProvider.run("send", formData, (d) => {
                  if (d.data && d.data.MESSAGE) {
                    Runtime.loadExtension("ui.dialogs.messagebox").then(
                      (exports) => {
                        const { MessageBox } = exports;
                        MessageBox.alert(d.data.MESSAGE);
                      }
                    );
                  }
                  let jsonModalParams = jsonForm.form.modal;
                  if (jsonModalParams) {
                    control.hide();
                  }
                });
              }
            };
            dataProvider.reset = () => {
              formUtil.resetForm(form);
            };
            if (data.vsControllerName)
              dataProvider.setControllerName(data.vsControllerName);
            let load = () => {
              let targetContainer = container;
              if (data.vsTargetContainer) {
                let c = document.querySelector(data.vsTargetContainer);
                if (c) targetContainer = c;
              }
              let jsonModalParams = jsonForm.form.modal;
              if (jsonModalParams) {
                Runtime.loadExtension("main.popup").then((exports) => {
                  const {
                    PopupMenu,
                    PopupMenuWindow,
                    PopupWindowButton,
                    PopupWindow,
                  } = exports;
                  let modalParams = {
                    //titleBar: 'rwerwer',
                    width: 400, // ширина окна
                    height: 600, // высота окна
                    zIndex: VSCore.zIndexNext(), // z-index
                    closeIcon: {
                      opacity: 1,
                    },
                    closeByEsc: true, // закрытие окна по esc
                    autoHide: false, // закрытие при клике вне окна
                    draggable: true, // можно двигать или нет
                    min_height: 600, // минимальная высота окна
                    min_width: 100, // минимальная ширина окна
                    lightShadow: true, // использовать светлую тень у окна
                    //angle: true, // появится уголок
                    resizable: true, // можно ресайзить
                    //offsetLeft: 30,
                    // offsetTop: 5,
                    drag_restrict: true,
                    resize_restrict: true,
                    overlay: {
                      backgroundColor: "black",
                      opacity: 500,
                    },
                    events: {
                      onPopupClose: function () {
                        control.__isOpen = false;
                      },
                    },
                    // events: {
                    //   onPopupShow: function () {
                    //     //this.contentContainer.innerHTML = '';
                    //   },
                    // },
                  };
                  var target_element;
                  if (type.isPlainObject(jsonModalParams)) {
                    if (jsonModalParams.params)
                      modalParams = VSCore.mergeEx(
                        modalParams,
                        jsonModalParams.params
                      );
                    if (
                      type.isArray(jsonModalParams.buttons) &&
                      jsonModalParams.buttons.length
                    ) {
                      modalParams.buttons = [];
                      jsonModalParams.buttons.forEach((item) => {
                        let btnParams = {
                          className: "btn btn-primary",
                        };
                        btnParams = VSCore.mergeEx(btnParams, item.params);
                        if (item.action == "send") {
                          btnParams.events = {
                            click: function (e) {
                              if (type.isFunction(dataProvider[item.action])) {
                                dataProvider[item.action](e, form, control);
                              }
                            },
                          };
                        } else if (item.action == "reset") {
                          btnParams.events = {
                            click: function (e) {
                              if (type.isFunction(dataProvider[item.action])) {
                                dataProvider[item.action](e, form, control);
                              }
                            },
                          };
                        }
                        modalParams.buttons.push(
                          new BX.PopupWindowButton(btnParams)
                        );
                      });
                    }
                    target_element = BX(jsonModalParams.target_element);
                  }

                  let popup = new BX.PopupWindow(
                    "popup_" + container.id,
                    target_element,
                    modalParams
                  );
                  dataProvider.setNode(popup.popupContainer);
                  form = formControl.createForm(
                    popup.contentContainer,
                    jsonForm,
                    dataProvider
                  );
                  let max_width = "calc(100% - 17px)";
                  if (modalParams.offsetLeft > 0) {
                    max_width =
                      "calc(100% - " + modalParams.offsetLeft * 2 + "px)";
                  }
                  popup.popupContainer.style.maxWidth = max_width;
                  control = VSCore.CONTROL.add(popup, jsonForm);
                  control.show();
                });
              } else {
                control = formControl.createForm(
                  targetContainer,
                  jsonForm,
                  dataProvider,
                  true
                );
                form = control.node;
                if (data.vsType == "click") {
                  dataProvider.setNode(form);
                }
                control.show();
              }
            };
            if (jsonForm) {
              load();
            } else {
              dataProvider.run("load", {}, (d) => {
                jsonForm = d.data;
                load();
              });
            }
          };
          if (!providerClass) {
            Runtime.loadExtension("vsbx.vsdefaultdataprovider").then(
              (exports) => {
                const { DefaultDataProvider } = exports;
                providerClass = DefaultDataProvider;
                createProvider();
              }
            );
          } else {
            createProvider();
          }
          init = true;
        }
      };

      if (data.vsType == "click") {
        container.addEventListener("click", function (e) {
          e.preventDefault();
          if (control) {
            if (control.__isOpen) {
              control.hide();
            } else {
              control.show();
            }
          } else {
            setInit();
          }
        });
      } else {
        if (
          (VSCore.isShown(container) && !isNodeHidden(container)) ||
          data.vsLoad
        ) {
          setInit();
        } else {
          arLazy.push({
            c: container,
            fu: setInit,
          });
        }
      }
    }
  });
  if (arLazy.length) {
    let myObserver, lazyLoad;
    lazyLoad = () => {
      let nArr = [];
      arLazy.forEach((item) => {
        if (VSCore.isShown(item.c) && !isNodeHidden(item.c)) {
          item.fu();
        } else {
          nArr.push(item);
        }
      });
      arLazy = nArr;
      if (nArr.length == 0) {
        myObserver.disconnect();
        Event.unbind(window, "scroll", lazyLoad);
        Event.unbind(window, "resize", lazyLoad);
      }
    };
    myObserver = new mutationObserver(lazyLoad);

    const obsConfig = {
      childList: true,
      characterData: true,
      attributes: true,
      subtree: true,
    };
    myObserver.observe(document.body, obsConfig);
    Event.bind(window, "scroll", lazyLoad);
    Event.bind(window, "resize", lazyLoad);
  }
};

ready(() => {
  setForm(document.body);
  const observer = new mutationObserver((mutations) => {
    for (let mutation of mutations) {
      for (let node of mutation.addedNodes) {
        // отслеживаем только узлы-элементы, другие (текстовые) пропускаем
        if (!(node instanceof HTMLElement)) continue;
        setForm(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

exports.FormUtil = formUtil;
exports.FormControl = formControl;
